<div class="modal-header blue">
  <h4 class="modal-title">Add Group to user</h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<form [formGroup]="vendorFiltersForm">
  <div class="modal-body flex-container">
    <div class="mb-3 pb-2" [class.disabled]="isLoading">
      <div class="form-row md">
        <div class="col-5">
          <span class="input-label">Enter Name</span>
          <input
            type="text"
            class="input"
            placeholder="Name"
            formControlName="name"
          />
        </div>

        <div class="col-5">
          <span class="input-label">Group ID</span>
          <input
            type="text"
            class="input"
            placeholder="Enter Group ID"
            formControlName="groupId"
          />
        </div>

        <div class="col-2">
          <button
            class="button-outline w-100"
            (click)="doSearch()"
            [disabled]="vendorFiltersForm.invalid"
          >
            Search
          </button>
        </div>
      </div>
    </div>

    <div [class.loading]="isLoading">
      <add-group-to-user-grid
        [userGroups]="userGroups"
        [userAccounts]="userAccounts"
        [isFromModal]="true"
        [searchParams]="searchParams"
        (groupsCheck)="setGroups($event)"
      >
      </add-group-to-user-grid>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="button w-134px ml-auto"
      (click)="addGroups()"
      [disabled]="!checkedProviderGroups?.length"
    >
      Add Groups
    </button>
  </div>
</form>
